import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HttpModule } from '@angular/http';
import { NgxPaginationModule} from 'ngx-pagination';
import { Ng2SearchPipe } from './filter.pipe';
import { Ng2OrderModule } from 'ng2-order-pipe';

import { LocationStatusComponent } from './location-status.component';
import { LocationStatusService } from './location-status.service';

@NgModule({
  declarations: [
    LocationStatusComponent,
    Ng2SearchPipe
  ],
  imports: [
    CommonModule,
    FormsModule,
    HttpModule,
    NgxPaginationModule,
    Ng2OrderModule,
    RouterModule
  ],
  providers: [LocationStatusService],
  bootstrap: [LocationStatusComponent],
  exports:   [Ng2SearchPipe]
})
export class LocationStatusModule { }



// WEBPACK FOOTER //
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/location-status/location-status.module.ts